export default __webpack_public_path__ + "static/media/Wolf's Leggings of the Wicked Hearth.c8b43cd2.jpg";